import axios from 'axios';
import SessaoAuth from '../Hooks/SessaoAuth';


const APIAxios = () => {

    const { sessao } = SessaoAuth();

    const instanceAxios = axios.create({
        baseURL: 'https://visionws.brisiq.com.br',
        //baseURL: 'http://localhost:8080',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Cache-Control': 'no-cache',
            'Accept': 'application/json',
            'APPToken': 'LtqpFZWwcyj8y6gqGdmTmqRjUw1h8quRTY0XHhGuymJ6X2Y3LYzObPJxzAeAo9sWY0hTTbLlWxE7XZCz5lte7XH8Alow',
        },
        withCredentials: false,
    });

    instanceAxios.interceptors.request.use((config) => {
        if (sessao.authToken) {
            config.headers.UserToken = `${sessao.authToken.token}`;
            config.headers.Authorization = `Bearer ${sessao.tokenEmpresa}`;
        }
        return config;
    });

    return instanceAxios;

};

export default APIAxios;
